import { useState, useEffect } from 'react';

export default function withAnimation(steps, play) {
  const [animationStep, setAnimationStep] = useState(0);
  const [currentValues, setCurrentValues] = useState(steps[0]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (play && animationStep < steps.length) {
        setCurrentValues(steps[animationStep]);
        setAnimationStep(animationStep + 1);
      }
    });
  }, [animationStep, play]);

  return currentValues;
}
